
import {defineComponent} from "vue";
import {trackGAEvent} from "@/utils/TrackingUtil";

export default defineComponent({
    name: "Button",
    emits: ['btn-click'],
    props: {
        text: String,
        title: String,
        design: {
            type: String,
            default: 'primary',
            validator: function (value: string): boolean {
                // The value must match one of these strings
                return ['primary', 'secondary'].indexOf(value) !== -1
            }
        },
        fullWidth: {
            type: Boolean,
            default: false
        },
        trackingCategory: String,
        trackingAction: String,
        trackingLabel: String
    },
    methods: {
        onClick() {
            if (this.trackingCategory && this.trackingCategory.length > 0 &&
                this.trackingAction && this.trackingAction.length > 0 &&
                this.trackingLabel && this.trackingLabel.length > 0) {
                trackGAEvent(this.trackingCategory, this.trackingAction, this.trackingLabel);
            }
            this.$emit('btn-click');
        }
    },
    computed: {
        hasSlotData(): boolean {
            return !!this.$slots.iconBefore || !!this.$slots.iconAfter;
        }
    }
});
